import { motion } from "framer-motion";
import { useLang } from "../../i18n";
import { Reveal, EASE } from "./Reveal";

export function CustomOrders() {
  const { t } = useLang();
  const titleLines = t.custom.title.split("\n");
  const scrollTo = (sel) => document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="custom" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="eyebrow mb-6">{t.custom.eyebrow}</p>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.02] tracking-tight mb-8">
              {titleLines.map((l, i) => (
                <span key={i} className="block">
                  {i === 1 ? <em className="italic text-[var(--gold-dark)]">{l}</em> : l}
                </span>
              ))}
            </h2>
            <p className="text-[var(--ink-2)] text-base md:text-lg leading-relaxed max-w-md mb-10">
              {t.custom.p}
            </p>
            <button
              data-testid="custom-cta"
              onClick={() => scrollTo("#contact")}
              className="group inline-flex items-center gap-3 border border-[var(--ink)]/25 rounded-full pl-7 pr-2 py-2 hover:border-[var(--gold)] transition-colors duration-500"
            >
              <span className="eyebrow text-[var(--ink)]">{t.custom.cta}</span>
              <span className="grid place-items-center w-9 h-9 rounded-full bg-[var(--gold-dark)] text-white group-hover:bg-[var(--ink)] transition-colors duration-500">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </span>
            </button>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 flex flex-col">
          {t.custom.steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-70px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              className="flex gap-6 md:gap-10 py-8 border-t border-[var(--ink)]/10 last:border-b"
            >
              <span className="font-display text-3xl md:text-4xl text-[var(--gold)]/50 leading-none pt-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h3 className="font-display text-2xl md:text-3xl mb-2">{s.t}</h3>
                <p className="text-[var(--ink-2)] leading-relaxed max-w-sm">{s.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
